import React from 'react'
import { useSlotRecipe, Box } from '@chakra-ui/react'
import { RichText } from '~/components/contentful/ContentfulRichText'
import {
  InteractivePodsCarousel,
  InteractivePodsGrid,
} from '~/components/search-and-results/InteractivePods'
import { useFeatureFlag } from '~/context/featureFlag'
import { useDeviceMatch } from '~/context/mediaQuery'
import { SearchTabQuery } from '~/schemas/searchPageParams'
import { MediaCard } from '~/components/search-and-results/Card'
import { ContentfulIntroSection } from '@reward-platform/contentful'
import { Box as AltoBox } from '@alto-avios/alto-ui'

type Props = {
  sectionContent: ContentfulIntroSection
  product: SearchTabQuery
}

export const RecommendedSection = ({ sectionContent: { content, cards = [] }, product }: Props) => {
  const recipe = useSlotRecipe({ key: 'recommendedSection' })
  const styles = recipe()
  const supportsClickablePodsCarousel = useFeatureFlag('clickable-pods-carousel')
  const { isDesktop } = useDeviceMatch()

  if (supportsClickablePodsCarousel) {
    return (
      <AltoBox
        data-testid="section-recommended"
        flexDirection="column"
        gap="lg"
        maxWidth="pageWidth"
        paddingTop="2xl"
        paddingBottom="2xl"
      >
        {content && (
          <AltoBox paddingX="xl">
            <RichText document={content} />
          </AltoBox>
        )}
        <AltoBox>
          {isDesktop ? (
            <InteractivePodsGrid cards={cards} product={product} />
          ) : (
            <InteractivePodsCarousel cards={cards} product={product} />
          )}
        </AltoBox>
      </AltoBox>
    )
  }

  return (
    <Box css={styles.container} data-testid="section-recommended">
      {content && (
        <Box css={styles.content}>
          <RichText document={content} />
        </Box>
      )}
      <Box css={styles.cards}>
        {cards?.map((item) => (
          <MediaCard key={JSON.stringify(item)} card={item} product={product} />
        ))}
      </Box>
    </Box>
  )
}
